/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

$dropdown-font-size: 18px !default;
$dropdown-small-font-size: 16px !default;
$dropdown-line-height: 22px !default;
$dropdown-small-line-height: 22px !default;
$dropdown-height: 44px !default;
$dropdown-small-height: 33px !default;
$dropdown-border-width: 2px !default;
$dropdown-border-width-bottom: 0px !default;
$dropdown-small-border-width: 1.5px !default;
$dropdown-border-active-width-bottom: 0px !default;
$dropdown-border-active-width: 3px !default;
$dropdown-small-border-active-width: 2.5px !default;
$dropdown-padding-x: 12px !default;
$dropdown-small-padding-x: 10px !default;
$dropdown-label-active-x-padding: 4px !default;
$dropdown-small-label-active-x-padding: 4px !default;
$dropdown-trailing-icon-padding-right: 0px !default;
$dropdown-small-trailing-icon-padding-right: 0px !default;
$dropdown-default-radius: 1px !default;
$dropdown-list-shadow: rgb(0 0 0 / 20%) 0px 5px 5px -3px, rgb(0 0 0 / 14%) 0px 8px 10px 1px,
  rgb(0 0 0 / 12%) 0px 3px 14px 2px !default;
$dropdown-outside-font-size: 14px !default;
$dropdown-label-outside-line-height: 18px !default;
$dropdown-label-outside-offset-left: 0px !default;
$dropdown-error-message-offset-left: 0px !default;

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

@mixin labelOutside {
  position: relative;
  font-size: $dropdown-outside-font-size;
  line-height: $dropdown-label-outside-line-height;
  margin-bottom: calc($dropdown-border-width + 4px);
  font-family: $font-family-base;
  color: v(labelColor);
  font-weight: normal;
  display: block;
  max-width: calc(100% - 8px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-left: $dropdown-label-outside-offset-left;
}

@mixin labelOutsideSmallOverwrites {
  margin-bottom: calc($dropdown-small-border-width + 4px);
}

@mixin label {
  position: absolute;
  left: $dropdown-padding-x;
  top: 11px;
  font-size: $dropdown-font-size;
  color: v(labelColor);
  font-weight: normal;
  line-height: $dropdown-line-height;
  pointer-events: none;
  transition-property: left, top, font-size, padding;
  transition-timing-function: ease;
  transition-duration: 0.2s;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - var(--labelOffset));
}

@mixin labelSmallOverwrites {
  top: 5px;
  left: $dropdown-small-padding-x;
  font-size: $dropdown-small-font-size;
}

@mixin labelActive {
  top: -12px;
  font-size: 14px;
  padding: 0 $dropdown-label-active-x-padding 0 $dropdown-label-active-x-padding;
  left: calc($dropdown-padding-x - $dropdown-label-active-x-padding);
  line-height: 18px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - var(--activeLabelOffset));
}

@mixin labelActiveSmallOverwrites {
  padding: 0 $dropdown-small-label-active-x-padding 0 $dropdown-small-label-active-x-padding;
  left: calc($dropdown-small-padding-x - $dropdown-small-label-active-x-padding);
}

:host {
  position: relative;
  width: 100%;
  @include eon-typography();
  display: flex;
  flex-direction: column;

  * {
    box-sizing: border-box;
  }
}

.#{$prefix}error-message {
  display: flex;
  color: v(errorMessageColor);
  margin-left: $dropdown-error-message-offset-left;
}

.#{$prefix}info-message {
  color: v(labelColor);
}

.#{$prefix}dropdown-info-icon {
  z-index: 10;
}

label.#{$prefix}outside {
  @include labelOutside;

  &.#{$prefix}small {
    @include labelOutsideSmallOverwrites;
  }

  &.#{$prefix}error {
    color: v(errorMessageColor);
  }

  &.#{$prefix}disabled {
    color: v(disabledLabelColor);
  }
}

.#{$prefix}dropdown-wrapper {
  width: 100%;
  display: flex;
  flex-flow: column;
  border-radius: $dropdown-default-radius;

  select {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    z-index: 10;
    font-size: $dropdown-font-size;

    &:focus {
      ~ .#{$prefix}dropdown-button {
        box-shadow: 0 $dropdown-border-active-width-bottom 0 $dropdown-border-active-width v(borderActiveColor) !important;
      }
    }
  }

  &.#{$prefix}touched {
    .#{$prefix}dropdown-button {
      ~ label {
        @include labelActive();
      }

      ~ .#{$prefix}label-placeholder {
        opacity: 1;
      }

      &.#{$prefix}collapsed {
        ~ label {
          color: v(labelColor);
        }
      }
    }
  }

  label {
    @include label();
    @include noneUserSelect();
    z-index: 1;
  }

  .#{$prefix}dropdown-button {
    @include eon-typography();
    width: 100%;
    height: $dropdown-height;
    display: flex;
    flex-direction: row;
    -webkit-appearance: none;
    outline: none;
    padding: 0;
    font-size: $dropdown-font-size;
    line-height: $dropdown-line-height;
    position: relative;
    border: none;
    box-shadow: 0 $dropdown-border-active-width-bottom 0 $dropdown-border-active-width v(borderActiveColor);
    border-radius: $dropdown-default-radius;

    &.#{$prefix}collapsed {
      border: none;
      box-shadow: 0 $dropdown-border-width-bottom 0 $dropdown-border-width v(borderColor);
      color: v(labelColor);

      ~ label {
        color: v(labelColor);
      }

      &:hover {
        box-shadow: 0 $dropdown-border-width-bottom 0 $dropdown-border-width v(borderHoverColor);

        .#{$prefix}icon-background {
          .#{$prefix}icon {
            fill: v(trailingIconColorActive);
          }
        }
      }

      .#{$prefix}icon-background {
        .#{$prefix}icon {
          transform: rotate(0deg);
          fill: v(trailingIconColor);
          right: inherit;
        }
      }
    }

    &:not(.#{$prefix}collapsed) {
      ~ label {
        @include labelActive();
      }

      ~ .#{$prefix}label-placeholder {
        opacity: 1;
      }
    }

    &:focus {
      box-shadow: 0 $dropdown-border-active-width-bottom 0 $dropdown-border-active-width v(borderActiveColor) !important;
    }

    &.#{$prefix}invalid {
      box-shadow: 0 $dropdown-border-active-width-bottom 0 $dropdown-border-active-width v(errorMessageColor) !important;

      & ~ label {
        color: v(errorMessageColor) !important;
      }
    }

    &.#{$prefix}disabled {
      box-shadow: 0 0 0 2px v(disabledBorderColor) !important;
      background-color: v(disabledBackgroundColor) !important;
      opacity: v(disabledOpacity);

      & ~ label {
        opacity: v(disabledOpacity);
      }

      .#{$prefix}option-label-wrapper {
        cursor: not-allowed;
      }

      .#{$prefix}icon-background {
        background-color: v(disabledBackgroundColor);
        cursor: not-allowed;

        .#{$prefix}icon {
          fill: v(disabledTrailingIconColor) !important;
        }
      }
    }

    .#{$prefix}icon-background {
      position: relative;
      height: $dropdown-height;
      background: v(trailingIconBackgroundColor);
      border-radius: 0 $dropdown-default-radius $dropdown-default-radius 0;
      cursor: pointer;
      z-index: 1;
      padding-right: $dropdown-trailing-icon-padding-right;

      .#{$prefix}icon-button {
        position: relative;
        width: 100%;
        height: 100%;
        padding: 0px 7px 0px 7px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .#{$prefix}icon {
        position: relative;
        transform: rotate(-180deg);
        height: auto;
        fill: v(trailingIconColorActive);
        transition: transform $transition-duration $transition-timing-function;
      }
    }

    .#{$prefix}option-label-wrapper {
      position: relative;
      height: $dropdown-height;
      width: 100%;
      line-height: $dropdown-line-height;
      padding: 11px $dropdown-padding-x 11px $dropdown-padding-x;
      border: none;
      align-self: center;
      justify-self: flex-start;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: v(labelColor);
      @include noneUserSelect();
      cursor: pointer;
    }
  }

  .#{$prefix}option-list {
    position: absolute;
    max-height: calc(100vh - 96px);
    width: 100%;
    margin: auto;
    background-color: v(optionsBackgroundColor);
    z-index: 96;
    top: 54px;
    overflow: auto;
    overflow-x: hidden;
    border-radius: $dropdown-option-option-list-radius;
    visibility: visible;
    opacity: 1;
    // transition: opacity $transition-duration $transition-timing-function,
    //   visibility $transition-duration $transition-timing-function;
    box-shadow: $dropdown-list-shadow;
  }

  .#{$prefix}option-list.#{$prefix}collapsed {
    width: 100%;
    visibility: hidden;
    opacity: 0;
    height: 0;
  }

  &.#{$prefix}small {
    label {
      @include labelSmallOverwrites();
    }

    .#{$prefix}option-list {
      top: 42px;
    }

    .#{$prefix}dropdown-button {
      font-size: $dropdown-small-font-size;
      line-height: $dropdown-small-line-height;
      height: $dropdown-small-height;
      box-shadow: 0 0 0 $dropdown-small-border-active-width v(borderActiveColor);

      &:not(.#{$prefix}collapsed) {
        ~ label {
          @include labelActiveSmallOverwrites();
        }
      }

      &:focus {
        box-shadow: 0 0 0 $dropdown-small-border-active-width v(borderActiveColor) !important;
      }

      &.#{$prefix}invalid {
        box-shadow: 0 0 0 $dropdown-small-border-active-width v(errorMessageColor) !important;
      }

      .#{$prefix}icon-background {
        height: $dropdown-small-height;
        width: auto;
        background: transparent;
        padding-right: $dropdown-small-trailing-icon-padding-right;

        .#{$prefix}icon-button {
          padding: 0px $dropdown-small-padding-x 0px ($dropdown-small-padding-x * 0.5);
        }
      }

      &.#{$prefix}collapsed {
        box-shadow: 0 0 0 $dropdown-small-border-width v(borderColor);

        &:hover {
          box-shadow: 0 0 0 $dropdown-small-border-width v(borderHoverColor);
        }

        .#{$prefix}icon-background {
          .#{$prefix}icon {
            transform: rotate(0deg);
          }
        }
      }

      .#{$prefix}option-label-wrapper {
        min-height: $dropdown-small-height;
        height: $dropdown-small-height;
        padding: 5px $dropdown-small-padding-x 5px $dropdown-small-padding-x;
      }
    }

    select {
      font-size: $dropdown-small-font-size;

      &:focus {
        ~ .#{$prefix}dropdown-button {
          box-shadow: 0 0 0 $dropdown-small-border-active-width v(borderActiveColor) !important;
        }
      }
    }

    &.#{$prefix}touched {
      .#{$prefix}dropdown-button {
        ~ label {
          @include labelActiveSmallOverwrites();
        }
      }
    }
  }
}

.#{$prefix}label-placeholder {
  @include labelActive();
  position: absolute;
  color: transparent;
  background: v(currentBackgroundColor);
  background: linear-gradient(
    0deg,
    transparent 0%,
    transparent 5.5px,
    v(currentBackgroundColor) 5.5px,
    v(currentBackgroundColor) 10px,
    transparent 10px,
    transparent 100%
  );
  z-index: 0;
  transition: opacity 0.15s ease-out 0s;
  opacity: 0;
}

.#{$prefix}option-info-wrapper {
  position: relative;
  width: auto;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0px 8px 0px 0px;
  gap: 16px;
}

.#{$prefix}multiselect-indicator {
  position: relative;
  width: auto;
  height: 24px;
  padding: 2px 2px 2px 10px;
  background-color: v(multiselectDeleteBackgroundColor); // turquoise dark
  color: v(multiselectDeleteFontColor);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 14px;
  line-height: 18px;
  font-family: $font-family-base;
  font-weight: 400;
  opacity: 0;
  visibility: hidden;
  /* transition-property: visibility, opacity, width;
  transition-duration: 0.2s;
  transition-timing-function: ease-in-out; */

  &.#{$prefix}visible {
    opacity: 1;
    visibility: visible;
  }

  .#{$prefix}multiselect-delete {
    position: relative;
    width: 20px;
    height: 20px;
    border-radius: 100%;
    background-color: rgba(255, 255, 255, 0.2);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition-property: background-color;
    transition-duration: 0.2s;
    transition-timing-function: ease-in-out;

    eon-ui-icon {
      fill: v(multiselectDeleteIconColor);
      color: v(multiselectDeleteIconColor);
      transition-property: fill, color;
      transition-duration: 0.2s;
      transition-timing-function: ease-in-out;
    }

    &:hover {
      background-color: rgba(255, 255, 255, 0.85);

      eon-ui-icon {
        fill: v(multiselectDeleteIconHoverColor);
        color: v(multiselectDeleteIconHoverColor);
      }
    }
  }
}
